module.exports = __webpack_public_path__ + "media/images/equipments-img-03-58971a505da45e29cf5ee0fc03b92391.png";